import React from "react";

const CryptoContext = React.createContext();

export default CryptoContext;